import React from 'react'
import OrganizationsPage from './OrganizationsPage';
import Header from 'components/VerticalLayout/Header';
import { Card, Col, Container, Row } from 'reactstrap';
import bgImage from "../../assets/images/bgImage1.jpg";

const OrganistaioMainPage = () => {
    document.title = "Title Appraiser | Organizations";

  return (
    <div className='account-pages'>
        <Header/>
        <div className='accountbg'
            style={{
            background: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment:"fixed",
            paddingTop:"80px",
            minHeight:"100vh",
            overflow:"hidden",
            paddingLeft:"8px"
            }}
        >
            <Container fluid>
                <Row>
                    <Col>
                        <Card style={{backdropFilter:"blur(10px)",opacity:"1"}}>
                            <OrganizationsPage/>
                        </Card>
                    </Col>
                </Row>
                
            </Container>
        </div>
    </div>
  )
}

export default OrganistaioMainPage